import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const CATEGORIES = ["All", "Music", "Photography"];

export default function Portfolio() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState("All");

  useEffect(() => {
    api.get("/portfolio").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const filtered = useMemo(
    () => (active === "All" ? items : items.filter((i) => i.category === active)),
    [items, active]
  );

  return (
    <section id="work" className="py-24 md:py-36 bg-charcoal text-warmwhite" data-testid="portfolio-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div>
            <p className="text-[11px] uppercase tracking-widest-custom text-gold mb-6">03 — Selected Work</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight max-w-3xl" data-testid="portfolio-title">
              Made with intention. <span className="italic text-gold">Built to last.</span>
            </h2>
          </div>
          <div className="flex flex-wrap gap-1" data-testid="portfolio-filters">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                data-testid={`portfolio-filter-${c.toLowerCase()}`}
                className={`px-5 py-2.5 text-[11px] uppercase tracking-widest-custom border transition-colors duration-300 ${
                  active === c
                    ? "border-gold bg-gold text-charcoal"
                    : "border-warmwhite/30 text-warmwhite/70 hover:border-warmwhite hover:text-warmwhite"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 md:gap-6">
          {filtered.map((p, i) => {
            const layouts = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-5", "lg:col-span-7", "lg:col-span-6", "lg:col-span-6"];
            const heights = ["aspect-[16/10]", "aspect-[4/5]", "aspect-[4/5]", "aspect-[16/10]", "aspect-[4/3]", "aspect-[4/3]"];
            return (
              <a
                href="#contact"
                key={p.id}
                data-testid={`portfolio-item-${p.id}`}
                className={`group relative block overflow-hidden bg-charcoal/40 ${layouts[i % layouts.length]}`}
              >
                <div className={`${heights[i % heights.length]} overflow-hidden`}>
                  <img
                    src={p.image}
                    alt={p.title}
                    className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal/85 via-charcoal/10 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 flex items-end justify-between">
                  <div>
                    <p className="text-[10px] uppercase tracking-widest-custom text-gold mb-2">{p.category}</p>
                    <h3 className="font-serif text-2xl md:text-3xl font-light leading-tight">{p.title}</h3>
                    <p className="hidden md:block mt-2 text-sm text-warmwhite/70 max-w-md">{p.description}</p>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
